module.exports = __webpack_public_path__ + "static/media/add doc.56ee7b43.svg";